import React, { FC, useEffect, useState } from 'react';
import { Input, InputGroup } from 'rsuite';
import {TfiSaveIcon} from "../../../models/Icons.model";
import {TimeControlInputProps} from "./TimeControlInput.model";

const TimeControlInput: FC<TimeControlInputProps> = ({
                                                       hour,
                                                       minute,
                                                       onTimeChanged,
                                                       loading = false,
                                                       onSave,
                                                       onUpdateTime,
                                                       maxHoursValue = 23,
                                                       readonly,
                                                       movementPermission,
                                                       autonomousEnabled,
                                                     }) => {
  const [localHours, setLocalHours] = useState<string>('');
  const [localMinutes, setLocalMinutes] = useState<string>('');
  const regex = /^\d*$/;

  useEffect(() => {
    setLocalHours(hour < 10 ? `0${hour}` : `${hour}`);
    setLocalMinutes(minute < 10 ? `0${minute}` : `${minute}`);
  }, [hour, minute]);

  const onChangeHours = (value: string) => {
    if (!regex.test(value)) return;

    const numValue = Number(value);
    if (numValue >= 0 && numValue <= maxHoursValue) {
      setLocalHours(value);
    }
  };

  const onChangeMinutes = (value: string) => {
    if (!regex.test(value)) return;

    const numValue = Number(value);
    if (numValue >= 0 && numValue <= 59) {
      setLocalMinutes(value);
    }
  };

  const onBlur = () => {
    const hoursNum = Number(localHours || 0);
    const minutesNum = Number(localMinutes || 0);

    const formattedHours = hoursNum < 10 ? `0${hoursNum}` : `${hoursNum}`;
    const formattedMinutes = minutesNum < 10 ? `0${minutesNum}` : `${minutesNum}`;

    setLocalHours(formattedHours);
    setLocalMinutes(formattedMinutes);

    onTimeChanged(hoursNum, minutesNum);
    if (onUpdateTime) {
      onUpdateTime();
    }
  };

  const handleSave = () => {
    const hoursNum = Number(localHours || 0);
    const minutesNum = Number(localMinutes || 0);

    const formattedHours = hoursNum < 10 ? `0${hoursNum}` : `${hoursNum}`;
    const formattedMinutes = minutesNum < 10 ? `0${minutesNum}` : `${minutesNum}`;

    setLocalHours(formattedHours);
    setLocalMinutes(formattedMinutes);
    onTimeChanged(hoursNum, minutesNum);

    if (onSave) {
      onSave(hoursNum, minutesNum);
    }
  };

  return (
    <InputGroup style={{ marginBottom: '5px' }}>
      <InputGroup.Addon>Полож. стрелок</InputGroup.Addon>

      <Input
        value={localHours}
        onChange={onChangeHours}
        onBlur={onBlur}
        style={{
          textAlign: 'center',
          backgroundColor: !movementPermission || !autonomousEnabled ? '#f58d7f' : '#d8e5fa',
        }}
        maxLength={2}
      />
      <InputGroup.Addon style={{ width: 5 }}>:</InputGroup.Addon>
      <Input
        value={localMinutes}
        onChange={onChangeMinutes}
        onBlur={onBlur}
        style={{
          textAlign: 'center',
          backgroundColor: !movementPermission || !autonomousEnabled ? '#f58d7f' : '#d8e5fa',
        }}
        maxLength={2}
      />

      {!readonly && (
        <InputGroup.Addon>
          <TfiSaveIcon
            style={{ cursor: 'pointer' }}
            onClick={handleSave}
            className={loading ? 'loading' : ''}
          />
        </InputGroup.Addon>
      )}
    </InputGroup>
  );
};

export default TimeControlInput;
